<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ f7205Header.ATTRIB_DESCRIPTION }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise" style="padding-top: 0 !important;">
  <div>
    <form name="screenFrom" id="screenFrom" class="form-horizontal" novalidate>

      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader) {
<div>
        <br />
        <div style="padding-bottom: 0 !important;">
          <div class="container-fluid">
            <!-- Entity info for non-exam scenario -->
            @if (!isExamScenario) {
<div class="row">
              <div class="col-md-6">
                <div class="col-md-1">
                  <span class="LayerLine1">Entity:</span>
                </div>
                <div class="col-md-10">
                  <span class="LayerData1">{{ rowData.LEID }} : {{ rowData.LE_NAME }} : {{ rowData.TAX_YEAR_BEGIN }} - {{ rowData.TAX_YEAR_END }}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="col-md-2">
                  <span class="LayerLine1">Business:</span>
                </div>
                <div class="col-md-9">
                  <span class="LayerData1">{{ rowData.ME_CODE }} - {{ rowData.ME_NAME }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="col-md-6">
                  <span class="LayerLine1">Tax Code:</span>
                </div>
                <div class="col-md-6">
                  <span class="LayerData1">{{ rowData.CDR_NO }}</span>
                </div>
              </div>
            </div>
}
            
            <!-- Entity info for exam scenario -->
            @if (isExamScenario) {
<div class="row">
              <div class="col-md-4">
                <div class="col-md-2">
                  <span class="LayerLine1">Entity:</span>
                </div>
                <div class="col-md-10">
                  <span class="LayerData1">{{ rowData.LEID }} : {{ rowData.LE_NAME }} : {{ rowData.TAX_YEAR_BEGIN }} - {{ rowData.TAX_YEAR_END }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="col-md-3">
                  <span class="LayerLine1">Business:</span>
                </div>
                <div class="col-md-9">
                  <span class="LayerData1">{{ rowData.ME_CODE }} - {{ rowData.ME_NAME }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="col-md-6">
                  <span class="LayerLine1">Tax Code:</span>
                </div>
                <div class="col-md-6">
                  <span class="LayerData1">{{ rowData.CDR_NO }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <span class="LayerLine1">Issue: {{ rowData.ISSUE_KEY }}</span>
              </div>
            </div>
}
          </div>

          <!-- Form Title -->
          <table class="InnerTblBG" style="width: 100%; border: 0px; font-weight: bold;">
            <tbody>
              <tr>
                <th class="BlackSmHdrBC">
                  <h4>{{ f7205Header.ATTRIB_DESCRIPTION }} <span style="color: red;"> (Inc/Dec)</span></h4>
                </th>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>

          <!-- Form Description with Info Icon -->
          <table class="InnerTblBG" style="width: 100%; border: 0px;">
            <tbody>
              <tr>
                <td style="width: 3px;">
                  <i class="fa fa-info-circle" style="font-size: 24px; color: skyblue"></i>
                </td>
                <td class="BlackTxtBL">
                  {{ f7205Header.ATTRIB_DESCRIPTION }} (Increase/Decrease Format)
                </td>
              </tr>
            </tbody>
          </table>

          <!-- NT Row Type Checkboxes -->
          <table class="InnerTblBG" style="width: 100%; border: 0px;">
            <tbody>
              <tr>
                @for (row1 of f7205NTList; track $index; let idx = $index) {
<td class="BlackTxtBL">
                  @if (idx === 0) {
<span>{{ row1.DESCRIPTION }}</span>
}
                  @if (idx !== 0) {

                    <input type="checkbox" 
                           [checked]="row1.ATTRIB_VALUE === 'Y' || row1.ATTRIB_VALUE === true"
                           (change)="headerCheckBox(row1, idx, $event)" 
                           style="margin-left: 10px;">
                    <span>{{ row1.ATTRIB_DESCRIPTION }}</span>
                  
}
                </td>
}
              </tr>
            </tbody>
          </table>

          <!-- Main Form Table -->
          <table class="table table-bordered form-inline InnerTblBG">
            @for (row of f7205FormData; track $index; let mainIndex = $index) {
<tr class="row">
              
              <!-- TH Row Type -->
              @if (row.ROW_TYPE==='TH') {

                @for (item of row.Line_data; track $index) {
<td 
                    style="font-weight: bold;" 
                    [attr.align]="item.COL_CLASS" 
                    [attr.colspan]="item.COLSPAN"
                    [ngClass]="{'color-red': item.ATTRIB_VALUE < 0}">
                  @if (item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt !== 0) {
<p style="color: red;">
                    {{ item.ATTRIB_VALUE | numberWithCommas }}
                  </p>
}
                  @if (item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt === 0) {
<p style="color: green;">
                    {{ item.ATTRIB_VALUE | numberWithCommas }}
                  </p>
}
                  @if (item.DESCRIPTION !== 'Unallocated Amount') {
<p>
                    {{ item.ATTRIB_VALUE | numberWithCommas }}
                  </p>
}
                </td>
}
              
}
              
              <!-- PH Row Type -->
              @if (row.ROW_TYPE==='PH') {
<td class="row" style="font-weight: bold;" colspan="12">
                {{ row.Line_data[0]?.LINE_NO }} {{ row.Line_data[0]?.DESCRIPTION }}
              </td>
}
              
              <!-- DT Row Type -->
              @if (row.ROW_TYPE==='DT') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td class="row" [attr.colspan]="item.COLSPAN">
                  @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='number') {
<p>
                    <input [(ngModel)]="item.ATTRIB_VALUE" 
                           [ngModelOptions]="{standalone: true}"
                           class="form-control input-md numText" 
                           type="text"
                           onlyDigitsDecimal
                           (blur)="updateAmount(itemIndex, item.LINE_NO)" 
                           (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)" 
                           [disabled]="item.IS_EDITABLE==='N'">
                    @if (item.HAS_ERROR==='Y') {
<span class="form-error-container">
                      {{ item.ATTRIB_VALUE_ERROR }}
                    </span>
}
                  </p>
}
                  @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>{{ item.ATTRIB_DESCRIPTION }}</p>
}
                </td>
}
              
}
              
              <!-- CH Row Type -->
              @if (row.ROW_TYPE==='CH') {
<td colspan="12">
                <table class="table table-bordered form-inline InnerTblBG">
                  @for (item of row.Line_data; track $index; let itemIndex = $index) {
<tr class="row">
                    
                    <!-- HEADER_ROW -->
                    @if (item.Line_Type==='HEADER_ROW') {

                      @for (column of item.Line_data_occ.slice(0, item.Line_data_occ.length - 1); track $index) {
<th class="row">
                        @if (column.ATTRIB_DESCRIPTION != 'Comments') {
<p>{{ column.ATTRIB_VALUE }}</p>
}
                      </th>
}
                    
}
                    
                    <!-- SUB_ROW -->
                    @if (item.Line_Type==='SUB_ROW') {
<td class="row">
                      {{ item.Line_no }}
                      <i class="fa fa-plus-circle color-green fa-lg pull-right"
                         style="cursor: pointer; margin-top: 4px;"
                         title="Add Details"
                         (click)="AddNewRow(item.Line_no)">
                      </i>
                    </td>
}
                    @if (item.Line_Type==='SUB_ROW') {
<td class="row" colspan="11">
                      Add Details
                    </td>
}
                    
                    <!-- DATA_ROW -->
                    @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {
<td class="row">
                      @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-pencil bluepencil pull-left"
                        
                         style="cursor: pointer; margin-top: 4px;"
                         title="Edit Details"
                         (click)="editExistingRecord(item.Line_no, item.Occurrence, itemIndex)">
                      </i>
}
                      @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-minus-circle color-red fa-lg pull-right"
                        
                         style="cursor: pointer; margin-top: 4px;"
                         title="Remove Details"
                         (click)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)">
                      </i>
}
                    </td>
}
                    @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {

                      @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length - 1); track $index) {
<td class="row">
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE == 'number') {
<p 
                           [ngClass]="{'color-red': column.ATTRIB_VALUE < 0}">
                          {{ column.ATTRIB_VALUE | numberWithCommas }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE != 'number' && column.ATTRIB_DESCRIPTION === 'Classification Type') {
<p>
                          {{ classification[column.ATTRIB_VALUE] }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE != 'number' && column.ATTRIB_DESCRIPTION !== 'Classification Type') {
<p>
                          {{ column.ATTRIB_VALUE }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                          @if (column.EDIT_TYPE==='select' && column.DATA_TYPE==='string' && column.ATTRIB_VALUE !== '1245' && column.ATTRIB_DESCRIPTION === 'Property Section') {
<button type="button" 
                                 
                                  style="border: none; padding: 0; background: none; color: Blue;"
                                  (click)="null">
                            (View/Edit)
                          </button>
}
                        </p>
}
                      </td>
}
                    
}
                    
                    <!-- DATA_COMMENTS -->
                    @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td class="row" style="text-align: left !important" colspan="2">
                      <h4 style="font-weight: bold;">{{ item.Line_data_occ[0]?.ATTRIB_DESCRIPTION }}:</h4>
                    </td>
}
                    @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td class="row" colspan="10">
                      {{ item.Line_data_occ[0]?.ATTRIB_VALUE }}
                    </td>
}
                    
                    <!-- NEW_EDIT_ROW -->
                    @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {
<td class="row">
                      <p>
                        <i class="fa fa-check-circle color-green fa-lg pull-left"
                           style="cursor: pointer; margin-top: 4px;"
                           title="Save Details"
                           (click)="saveNewEdittedRecord(item.Line_no, item.Occurrence, itemIndex)">
                        </i>
                        <i class="fa fa-minus-circle color-red fa-lg pull-right"
                           style="cursor: pointer; margin-top: 4px;"
                           title="Remove Details"
                           (click)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)">
                        </i>
                      </p>
                    </td>
}
                    @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {

                      @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length - 1); track $index; let colIndex = $index) {
<td class="row">
                        @if (column.EDIT_TYPE==='label' && column.DATA_TYPE==='number') {
<p>
                          {{ column.ATTRIB_VALUE }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string') {
<p>
                          <input type="checkbox" 
                                 [checked]="column.ATTRIB_VALUE === 'Y'"
                                 (change)="onCheckboxChange(column, itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)">
                        </p>
}
                        
                        @if (column.EDIT_TYPE==='select' && column.DATA_TYPE==='string' && column.ATTRIB_DESCRIPTION === 'Property Section') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE"
                                  [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="valuechanged(itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                  class="form-control">
                            @for (sec of section; track $index) {
<option [value]="sec">{{ sec }}</option>
}
                          </select>
                        </p>
}
                        
                        @if (column.EDIT_TYPE === 'select' && column.DATA_TYPE === 'string' && column.ATTRIB_DESCRIPTION === 'Classification Type') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE"
                                  [ngModelOptions]="{standalone: true}"
                                  class="classification-dropdown"
                                  (ngModelChange)="valuechanged(itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)">
                            @for (item of (classification | keyvalue); track item.key) {
<option [value]="item.key">{{ item.value }}</option>
}
                          </select>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        
                        @if (column.EDIT_TYPE==='text' && column.DATA_TYPE==='string') {
<p>
                          <textarea style="width: 100%" 
                                    class="form-control input-sm numText"
                                    [(ngModel)]="column.ATTRIB_VALUE"
                                    [ngModelOptions]="{standalone: true}"
                                    placeholder="<-- Description -->"
                                    (ngModelChange)="valuechanged(itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex)">
                          </textarea>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        
                        @if (column.EDIT_TYPE==='currency' && column.DATA_TYPE==='number') {
<p>
                          <input [(ngModel)]="column.ATTRIB_VALUE" 
                                 [ngModelOptions]="{standalone: true}"
                                 class="form-control input-md numText" 
                                 type="text"
                                 onlyDigitsDecimal
                                 (blur)="updateAmount(itemIndex, column.LINE_NO)" 
                                 (ngModelChange)="valuechanged(itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex)">
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        
                        @if (column.EDIT_TYPE==='checkbox' && column.DATA_TYPE==='string') {
<p>
                          <input type="checkbox" 
                                 [checked]="column.ATTRIB_VALUE === 'Y'"
                                 (change)="onCheckboxChange(column, itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)">
                        </p>
}
                        
                        @if (column.EDIT_TYPE==='custom_date_various' && column.DATA_TYPE==='dateVarious') {
<div 
                             class="form-inline" style="white-space: nowrap; min-width: 150px;">
                          <div class="form-group" style="margin: 0">
                            <input type="checkbox" 
                                   [checked]="column.ATTRIB_VALUE === 'VARIOUS'" 
                                   (change)="onDateVariousCheckboxChange(column, itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)"
                                   title="Various"
                                   style="margin-right: 5px;">
                          </div>
                          <div class="form-group" style="margin: 0">
                            @if (column.ATTRIB_VALUE !== 'VARIOUS') {
<input 
                                   type="date" 
                                   class="form-control"
                                   [ngModel]="convertToHtmlDateFormat(column.ATTRIB_VALUE)"
                                   [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="column.ATTRIB_VALUE = $event; valuechanged(itemIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                   style="min-width: 150px;">
}
                            @if (column.ATTRIB_VALUE === 'VARIOUS') {
<input 
                                   type="text" 
                                   class="form-control" 
                                   value="VARIOUS" 
                                   disabled
                                   style="min-width: 150px;">
}
                          </div>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </div>
}
                      </td>
}
                    
}
                    
                    <!-- NEW_EDIT_COMMENT_ROW -->
                    @if (item.Line_Type==='NEW_EDIT_COMMENT_ROW' && item.Is_Multi==='Y') {
<td class="row" style="text-align: left !important" colspan="2">
                      <h4 style="font-weight: bold;">{{ item.Line_data_occ[0]?.ATTRIB_DESCRIPTION }}:</h4>
                    </td>
}
                    @if (item.Line_Type==='NEW_EDIT_COMMENT_ROW' && item.Is_Multi==='Y') {
<td class="row" colspan="10">
                      <textarea style="width: 100%" 
                                class="form-control input-sm"
                                [(ngModel)]="item.Line_data_occ[0].ATTRIB_VALUE"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="<--- Enter Comments here --->"
                                (ngModelChange)="valuechanged(itemIndex, item.Line_data_occ[0].OCCURRENCE, item.Line_data_occ[0].LINE_NO, itemIndex)">
                      </textarea>
                    </td>
}
                  </tr>
}
                </table>
              </td>
}
            </tr>
}
          </table>
        </div>
      </div>
}
    </form>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise" style="padding-top: 0 !important;">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked || !isValidScenario" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">
    Reset
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">
    Cancel
  </button>
</div>

